import { queries } from "lib/build/dashboards/htx/queries";
import { Origin } from "lib/build/events";

import { getNumberOfDays } from "src/common/utils/dates";
import { useLastEventByQuery } from "src/features/events";

export function useWaitingListTime(): {
	value: number | undefined;
	timestamp?: string;
	origin?: Origin;
} {
	const event = useLastEventByQuery<Date>(queries.waitingListStartDate);
	if (event === undefined) {
		return { value: undefined };
	}
	return {
		value: getNumberOfDays(event.value, new Date()),
		timestamp: event.timestamp,
		origin: event.origin
	};
}
